// Bare `<Name>` roots of every `Icon<Name>Fill18` export in nucleo-ui-fill-18,
// kept dependency-free so the API can validate article icons. Regenerate with
// the parity test in apps/app/src/components/nucleo-icon-names.test.ts.
export const NUCLEO_ICON_NAMES: readonly string[] = [
	"AbstractDots",
	"Accessibility",
	"AddAbove",
	"AddBelow",
	"AddItem",
	"AddMagic",
	"AddSection",
	"AddressBook",
	"AdjustContrast",
	"AdjustContrast2",
	"AiDeveloper",
	"AiLoading",
	"AirBaloon",
	"Airbag",
	"Airplay",
	"AlarmAlert",
	"AlarmCheck",
	"AlarmClock",
	"AlarmMinus",
	"AlarmOff",
	"AlarmPlus",
	"Album",
	"Album2",
	"Album3",
	"AlertInfo",
	"AlertQuestion",
	"AlertWarning",
	"Align2Bottom",
	"Align2DistributeHorizontal",
	"Align2DistributeVertical",
	"Align2Horizontal",
	"Align2Left",
	"Align2Right",
	"Align2Top",
	"Align2Vertical",
	"Align3Bottom",
	"Align3Horizontal",
	"Align3Left",
	"Align3Right",
	"Align3Top",
	"Align3Vertical",
	"AlignBottom",
	"AlignDistributeHorizontal",
	"AlignDistributeVertical",
	"AlignHorizontal",
	"AlignLeft",
	"AlignRight",
	"AlignTidyUp",
	"AlignTop",
	"AlignVertical",
	"Ambulance",
	"Anchor",
	"Angle",
	"AngleDotted",
	"AnimationBounce",
	"AnimationFast",
	"AnimationFrames",
	"AnimationObj",
	"AnimationRepeat",
	"Antenna",
	"ApartmentBuilding",
	"Aperture",
	"AppStack",
	"AppStore",
	"Apple",
	"Applications",
	"Archive",
	"Archive2",
	"ArchiveBookmark",
	"ArchiveCheck",
	"ArchiveClock",
	"ArchiveContent",
	"ArchiveContent2",
	"ArchiveDownload",
	"ArchiveExport",
	"ArchiveExport2",
	"ArchiveMinus",
	"ArchivePencil",
	"ArchivePlus",
	"ArchiveSearch",
	"ArchiveSparkle",
	"ArchiveSync",
	"AreaLight",
	"Armchair",
	"ArrowAnticlockwiseText",
	"ArrowBackToBottomLeft",
	"ArrowBackToBottomRight",
	"ArrowBackToUpLeft",
	"ArrowBackToUpRight",
	"ArrowBoldDown",
	"ArrowBoldDownFromLine",
	"ArrowBoldDownToLine",
	"ArrowBoldLeft",
	"ArrowBoldLeftFromLine",
	"ArrowBoldLeftToLine",
	"ArrowBoldRight",
	"ArrowBoldRightFromLine",
	"ArrowBoldRightSparkle",
	"ArrowBoldRightToLine",
	"ArrowBoldUp",
	"ArrowBoldUpFromLine",
	"ArrowBoldUpToLine",
	"ArrowCornerBottomLeft",
	"ArrowCornerBottomRight",
	"ArrowCornerUpLeft",
	"ArrowCornerUpRight",
	"ArrowDashedRotateAnticlockwise",
	"ArrowDashedRotateClockwise",
	"ArrowDiagonalIn",
	"ArrowDiagonalIn2",
	"ArrowDoorIn",
	"ArrowDoorIn2",
	"ArrowDoorOut",
	"ArrowDoorOut2",
	"ArrowDoorOut3",
	"ArrowDotRotateAnticlockwise",
	"ArrowDotRotateClockwise",
	"ArrowDottedRotateAnticlockwise",
	"ArrowDown",
	"ArrowDownFromLine",
	"ArrowDownLeft",
	"ArrowDownRight",
	"ArrowDownToLine",
	"ArrowFromCornerBottomLeft",
	"ArrowFromCornerBottomRight",
	"ArrowFromCornerUpLeft",
	"ArrowFromCornerUpRight",
	"ArrowLeft",
	"ArrowLeftFromLine",
	"ArrowLeftToLine",
	"ArrowMoveToBottom",
	"ArrowMoveToTop",
	"ArrowPerspDoorIn",
	"ArrowPerspDoorOut",
	"ArrowRight",
	"ArrowRightFromLine",
	"ArrowRightToLine",
	"ArrowRotate",
	"ArrowRotateAnticlockwise",
	"ArrowRotateAnticlockwiseCheck",
	"ArrowRotateAnticlockwiseSlash",
	"ArrowRotateAnticlockwiseXmark",
	"ArrowRotateClockwise",
	"ArrowRotateClockwisePlus",
	"ArrowRotateClockwiseSlash",
	"ArrowSymbolDown",
	"ArrowSymbolDownLeft",
	"ArrowSymbolDownRight",
	"ArrowSymbolLeft",
	"ArrowSymbolRight",
	"ArrowSymbolUp",
	"ArrowSymbolUpLeft",
	"ArrowSymbolUpRight",
	"ArrowThroughCircleRight",
	"ArrowThroughLineDown",
	"ArrowThroughLineLeft",
	"ArrowThroughLineRight",
	"ArrowThroughLineUp",
	"ArrowToCornerBottomLeft",
	"ArrowToCornerBottomRight",
	"ArrowToCornerTopLeft",
	"ArrowToCornerTopRight",
	"ArrowTrendDown",
	"ArrowTrendUp",
	"ArrowTriangleLineDown",
	"ArrowTriangleLineExpand",
	"ArrowTriangleLineExpandDiagonal",
	"ArrowTriangleLineExpandDiagonal2",
	"ArrowTriangleLineExpandDiagonal3",
	"ArrowTriangleLineExpandDiagonal4",
	"ArrowTriangleLineLeft",
	"ArrowTriangleLineMinimizeDiagonal",
	"ArrowTriangleLineMinimizeDiagonal2",
	"ArrowTriangleLineRight",
	"ArrowTriangleLineUp",
	"ArrowTurnDown",
	"ArrowTurnDown2",
	"ArrowTurnLeft",
	"ArrowTurnLeft2",
	"ArrowTurnRight",
	"ArrowTurnRight2",
	"ArrowTurnUp",
	"ArrowTurnUp2",
	"ArrowUp",
	"ArrowUpDownTrail",
	"ArrowUpFromLine",
	"ArrowUpLeft",
	"ArrowUpRight",
	"ArrowUpToLine",
	"ArrowsAllDirections",
	"ArrowsBoldOppositeDirection",
	"ArrowsConverge",
	"ArrowsCross",
	"ArrowsDiagonalOppositeDirection",
	"ArrowsDiagonalOppositeDirection2",
	"ArrowsExpand",
	"ArrowsExpandDiagonal",
	"ArrowsExpandDiagonal2",
	"ArrowsExpandDiagonal3",
	"ArrowsExpandDiagonal4",
	"ArrowsExpandDiagonal5",
	"ArrowsExpandDiagonal6",
	"ArrowsExpandX",
	"ArrowsExpandY",
	"ArrowsFilter",
	"ArrowsFromLineX",
	"ArrowsFromLineY",
	"ArrowsLeftRightTrail",
	"ArrowsOppositeDirectionX",
	"ArrowsOppositeDirectionY",
	"ArrowsReduceDiagonal",
	"ArrowsReduceDiagonal2",
	"ArrowsReduceX",
	"ArrowsReduceY",
	"ArrowsRotateCenter",
	"ArrowsSpin",
	"ArrowsThroughLineX",
	"ArrowsThroughLineY",
	"ArrowsToCenter",
	"ArrowsToLineX",
	"ArrowsToLineY",
	"ArrowsToLineY2",
	"ArrowsTransaction",
	"ArrowsUpRightDownLeft",
	"ArtificialIntelligence",
	"AscendingSorting",
	"AspectRatioHorizontal",
	"AspectRatioHorizontal2",
	"AspectRatioSquare",
	"AspectRatioSquare2",
	"AspectRatioVertical",
	"AspectRatioVertical2",
	"Asterisk",
	"AtSign",
	"AtmMachine",
	"Atom",
	"Atom2",
	"AudioDescription",
	"AugmentedReality",
	"AugmentedReality2",
	"AutoFocus",
	"AutomatedLogistics",
	"AutomatedLogistics2",
	"Award",
	"Award2",
	"AwardCertificate",
	"AwardPlaque",
	"Axis",
	"Axis2",
	"AxisDottedX",
	"AxisDottedY",
	"AxisDottedZ",
	"AxisX",
	"AxisY",
	"AxisZ",
	"BabyCarSeat",
	"BabyCarriage",
	"BabyClothes",
	"Backpack",
	"Backpack2",
	"Backpack3",
	"Backpack4",
	"Backpack5",
	"BadgeCheck",
	"BadgeCheck2",
	"BadgeDollar",
	"Bag",
	"BagAlert",
	"BagCheck",
	"BagClock",
	"BagCursor",
	"BagLink",
	"BagMinus",
	"BagOutForDelivery",
	"BagPen",
	"BagPlus",
	"BagRefresh",
	"BagSearch",
	"BagShopping",
	"BagShopping2",
	"BagUser",
	"BagXmark",
	"Balance",
	"Balance2",
	"BalanceOff",
	"BalanceOff2",
	"BallBaseball",
	"BallBasket",
	"BallBasket2",
	"BallBowling",
	"BallCrystal",
	"BallEatingDots",
	"BallGolf",
	"BallPool8",
	"BallRugby",
	"BallSoccer",
	"BallTennis",
	"BallVolleyball",
	"BallotCircle",
	"BallotRect",
	"Baloon",
	"Baloon2",
	"BaloonHeart",
	"BaloonsHeart",
	"Bamboo",
	"Ban",
	"BankStatement",
	"BankingMobile",
	"BankingOnline",
	"Barcode",
	"BarcodeRead",
	"BarcodeScan",
	"BarsFilter",
	"BaseballCap",
	"Basement",
	"BasketShopping",
	"Bathrobe",
	"Bathtub",
	"Battery",
	"BatteryAlert",
	"BatteryCharging",
	"BatteryFull",
	"BatteryHigh",
	"BatteryLow",
	"BatteryMedium",
	"Bed",
	"BedDouble",
	"BedEmpty",
	"BedSingle",
	"Bell",
	"BellDot",
	"BellMinus",
	"BellOn",
	"BellPlus",
	"BellSlash",
	"BellSnooze",
	"Belt",
	"Bicep",
	"Bicycle",
	"Bicycle2",
	"BicycleElectric",
	"BikeDelivery",
	"Binary",
	"Birdhouse",
	"Bitcoin",
	"Bitcoin2",
	"Blockquote",
	"Blog",
	"Blueprint",
	"Bolt",
	"BoltLightning",
	"BoltLightningSlash",
	"BoltSlash",
	"BoltSpeed",
	"Bomb",
	"Bomb2",
	"BombSparkle",
	"Book",
	"Book2",
	"BookBookmark",
	"BookOpen",
	"BookOpen2",
	"BookOpen3",
	"BookOpen4",
	"BookOpen5",
	"BookSettings",
	"BookWrench",
	"Bookmark",
	"BookmarkCheck",
	"BookmarkList",
	"BookmarkMinus",
	"BookmarkMinus2",
	"BookmarkPlus",
	"BookmarkPlus2",
	"BookmarkSlash",
	"BookmarkedBook",
	"BookmarkedBook2",
	"Bookmarks",
	"Books",
	"Books2",
	"BooleanExclude",
	"BooleanFlatten",
	"BooleanIntersect",
	"BooleanSubtract",
	"BooleanUnion",
	"Boot",
	"Border",
	"BorderBottom",
	"BorderBottomLeft",
	"BorderBottomRight",
	"BorderCenterX",
	"BorderCenterY",
	"BorderLeft",
	"BorderNone",
	"BorderRight",
	"BorderTop",
	"BorderTopLeft",
	"BorderTopRight",
	"BorderWidth",
	"BorderX",
	"BorderY",
	"Bottle",
	"BottleChampagne",
	"BottleWater",
	"BottleWine",
	"Bow",
	"BowTie",
	"BowlFood",
	"Box",
	"Box2",
	"Box2ArrowDown",
	"Box2Check",
	"Box2Clock",
	"Box2Minus",
	"Box2Plus",
	"Box2Search",
	"Box3",
	"BoxAlert",
	"BoxArchive",
	"BoxArchive2",
	"BoxArchive2Download",
	"BoxArchive3",
	"BoxArchiveDownload",
	"BoxArrowDown",
	"BoxCart",
	"BoxCheck",
	"BoxClock",
	"BoxDoor",
	"BoxHeart",
	"BoxLock",
	"BoxMinus",
	"BoxPin",
	"BoxPlus",
	"BoxScale",
	"BoxSearch",
	"BoxShield",
	"BoxSparkle",
	"BoxSparkle2",
	"BoxingGlove",
	"Bra",
	"BracketsCurly",
	"BracketsCurlyDots",
	"BracketsCurlySparkle",
	"BracketsSquare",
	"BracketsSquareDots",
	"Brain",
	"BrainNodes",
	"BrainNodes2",
	"BrainSparkle",
	"BranchMerge",
	"BranchOut",
	"Bricks",
	"BrightnessDecrease",
	"BrightnessIncrease",
	"Brochure",
	"Broom",
	"BroomSparkle",
	"Brush",
	"Brush2",
	"Bucket",
	"Bucket2",
	"Bucketpaint",
	"Bucketpaint2",
	"Bug",
	"BugSlash",
	"BulletList",
	"Bullhorn",
	"Bullseye",
	"Burger",
	"Burger2",
	"BurgerSlash",
	"Bus",
	"Butterfly",
	"Button",
	"ButtonCursor",
	"ButtonPlus",
	"Cake",
	"Calculator",
	"Calculator2",
	"Calculator3",
	"Calendar",
	"CalendarAlert",
	"CalendarAlert2",
	"CalendarAttachment",
	"CalendarBolt",
	"CalendarBookmark",
	"CalendarCheck",
	"CalendarCheck2",
	"CalendarCheckIn",
	"CalendarCheckOut",
	"CalendarClock",
	"CalendarCloud",
	"CalendarDate",
	"CalendarDays",
	"CalendarDots",
	"CalendarDownload",
	"CalendarEvent",
	"CalendarFeather",
	"CalendarGrid",
	"CalendarHeart",
	"CalendarKey",
	"CalendarLink",
	"CalendarLock",
	"CalendarMinus",
	"CalendarMinus2",
	"CalendarPen",
	"CalendarPhone",
	"CalendarPin",
	"CalendarPlanning",
	"CalendarPlus",
	"CalendarPlus2",
	"CalendarRefresh",
	"CalendarSearch",
	"CalendarSettings",
	"CalendarShield",
	"CalendarSparkle",
	"CalendarStar",
	"CalendarUpdate",
	"CalendarUser",
	"CalendarXmark",
	"Camera",
	"Camera2",
	"Camera2Off",
	"Camera3",
	"Camera3Off",
	"CameraOff",
	"CameraSparkle",
	"Candle",
	"Candy",
	"Car",
	"CarElectric",
	"CarSide",
	"CarVentilation",
	"CardSparkle",
	"Cards",
	"CaretAllDirections",
	"CaretDown",
	"CaretDownFromLine",
	"CaretDownToLine",
	"CaretExpandX",
	"CaretExpandY",
	"CaretLeft",
	"CaretLeftFromLine",
	"CaretLeftToLine",
	"CaretMaximize",
	"CaretMaximizeDiagonal",
	"CaretMaximizeDiagonal2",
	"CaretMinimize",
	"CaretMinimizeDiagonal",
	"CaretMinimizeDiagonal2",
	"CaretReduceX",
	"CaretReduceY",
	"CaretRight",
	"CaretRightFromLine",
	"CaretRightToLine",
	"CaretUp",
	"CaretUpFromLine",
	"CaretUpRightDownLeft",
	"CaretUpToLine",
	"Carousel",
	"Carousel2",
	"CartAlert",
	"CartArrowDown",
	"CartBolt",
	"CartHeart",
	"CartKey",
	"CartMinus",
	"CartPen",
	"CartPlus",
	"CartRefresh",
	"CartShopping",
	"CartUpdate",
	"CartUser",
	"Cat",
	"Chair",
	"Chair2",
	"Chair3",
	"Chair4",
	"Chair5",
	"ChampagneGlasses",
	"ChargingStation",
	"Chart",
	"Chart2",
	"Chart3",
	"ChartActivity",
	"ChartActivity2",
	"ChartActivity3",
	"ChartArea",
	"ChartArea2",
	"ChartBar",
	"ChartBarAxisX",
	"ChartBarAxisY",
	"ChartBarTrendDown",
	"ChartBarTrendUp",
	"ChartBubble",
	"ChartCandlestick",
	"ChartCandlestick2",
	"ChartCircular",
	"ChartCircular2",
	"ChartColumn",
	"ChartColumnHorizontal",
	"ChartColumnTrendDown",
	"ChartColumnTrendUp",
	"ChartCombo",
	"ChartDonut",
	"ChartDonut2",
	"ChartDonut3",
	"ChartGantt",
	"ChartHistogram",
	"ChartHistory",
	"ChartLine",
	"ChartLine2",
	"ChartLineDot",
	"ChartPie",
	"ChartPie2",
	"ChartPyramid",
	"ChartRadar",
	"ChartScatter",
	"ChartStackedArea",
	"ChartStackedBar",
	"ChartStackedLine",
	"ChartStockPrice",
	"ChartTrendDown",
	"ChartTrendUp",
	"ChartUsage",
	"ChatBot",
	"ChatBubble",
	"ChatBubbleArrowRight",
	"ChatBubbleCheck",
	"ChatBubbleClip",
	"ChatBubbleClock",
	"ChatBubbleContent",
	"ChatBubbleFlag",
	"ChatBubbleForward",
	"ChatBubbleHeart",
	"ChatBubbleLock",
	"ChatBubblePen",
	"ChatBubblePlus",
	"ChatBubbleQuote",
	"ChatBubbleSmile",
	"ChatBubbleSparkle",
	"ChatBubbleStar",
	"ChatBubbleUser",
	"ChatBubbleUser2",
	"ChatBubbleWriting",
	"ChatImage",
	"ChatInfo",
	"ChatTask",
	"Chats",
	"Check",
	"Check2",
	"Check3",
	"CheckBoxArrow",
	"CheckDouble",
	"CheckList",
	"CheckUnderline",
	"CheckboxChecked",
	"CheckboxUnchecked",
	"ChefHat",
	"Chess",
	"ChessKnight",
	"ChessQueen",
	"ChevronAllDirections",
	"ChevronDown",
	"ChevronExpandX",
	"ChevronExpandY",
	"ChevronLeft",
	"ChevronLeftToLine",
	"ChevronMaximizeDiagonal",
	"ChevronMaximizeDiagonal2",
	"ChevronMinimizeDiagonal",
	"ChevronMinimizeDiagonal2",
	"ChevronReduceX",
	"ChevronReduceY",
	"ChevronRight",
	"ChevronRightToLine",
	"ChevronSquareAllDirections",
	"ChevronUp",
	"ChevronUpRightDownLeft",
	"Child",
	"ChildHead",
	"Church",
	"Church2",
	"CircleArrowDown",
	"CircleArrowIn",
	"CircleArrowLeft",
	"CircleArrowOut",
	"CircleArrowRight",
	"CircleArrowUp",
	"CircleArrowsOppositeDirection",
	"CircleAsterisk",
	"CircleBarsFilter",
	"CircleBitcoin",
	"CircleBolt",
	"CircleCaretDown",
	"CircleCaretLeft",
	"CircleCaretRight",
	"CircleCaretUp",
	"CircleChartLine",
	"CircleChartLine2",
	"CircleCheck",
	"CircleCheck2",
	"CircleCheck3",
	"CircleCheckPlus",
	"CircleCheckPlus2",
	"CircleChevronDown",
	"CircleChevronExpand",
	"CircleChevronExpand2",
	"CircleChevronLeft",
	"CircleChevronRight",
	"CircleChevronUp",
	"CircleCoinIn",
	"CircleCoinOut",
	"CircleCoinPlus",
	"CircleCompose",
	"CircleCompose2",
	"CircleCompose3",
	"CircleConversion",
	"CircleCopy",
	"CircleCopy2",
	"CircleCopyPlus",
	"CircleCopyPlus2",
	"CircleCross",
	"CircleDashed",
	"CircleDashedClock",
	"CircleDollar",
	"CircleDollarDown",
	"CircleDollarIn",
	"CircleDollarOut",
	"CircleDollarUp",
	"CircleDots",
	"CircleDotsVertical",
	"CircleDotted",
	"CircleDottedClock",
	"CircleDottedUser",
	"CircleGridDots",
	"CircleHalfArrowDown",
	"CircleHalfArrowLeft",
	"CircleHalfArrowRight",
	"CircleHalfArrowUp",
	"CircleHalfDashedCheck",
	"CircleHalfDashedPause",
	"CircleHalfDashedStop",
	"CircleHalfDottedChart",
	"CircleHalfDottedChart2",
	"CircleHalfDottedCheck",
	"CircleHalfDottedClock",
	"CircleHalfDottedSparkle",
	"CircleHashtag",
	"CircleImage",
	"CircleInfinity",
	"CircleInfo",
	"CircleInfoSparkle",
	"CircleKey",
	"CircleLock",
	"CircleLogin",
	"CircleLogout",
	"CircleMinus",
	"CircleMusicNote",
	"CircleNumberOne",
	"CircleOpenArrowDown",
	"CircleOpenArrowLeft",
	"CircleOpenArrowRight",
	"CircleOpenArrowUp",
	"CircleOpenArrowUpLeft",
	"CircleOpenArrowUpRight",
	"CircleOpenDownLeft",
	"CircleOpenDownRight",
	"CirclePause",
	"CirclePencil",
	"CirclePercentage",
	"CirclePlay",
	"CirclePlus",
	"CirclePlusMinus",
	"CirclePowerOff",
	"CircleQuestion",
	"CircleSignal",
	"CircleSliders",
	"CircleSortArrows",
	"CircleSparkle",
	"CircleStop",
	"CircleUser",
	"CircleUserCheck",
	"CircleUserMinus",
	"CircleUserPlus",
	"CircleUserSparkle",
	"CircleUserSparkle2",
	"CircleWarning",
	"CircleWaveformLines",
	"CircleXmark",
	"Circles",
	"Circles2",
	"Circles3",
	"Circles4",
	"Circles5",
	"Circuits",
	"Circuits2",
	"Clapperboard",
	"ClapperboardPlay",
	"ClearTextFormatting",
	"Clipboard",
	"ClipboardArrowIn",
	"ClipboardArrowOut",
	"ClipboardCheck",
	"ClipboardClock",
	"ClipboardContent",
	"ClipboardDocument",
	"ClipboardList",
	"ClipboardSlash",
	"ClipboardUser",
	"Clock",
	"Clock2",
	"ClockCoins",
	"ClockMinus",
	"ClockPlus",
	"ClockRotateAnticlockwise",
	"ClockRotateClockwise",
	"ClockRotateClockwise2",
	"ClockRotateClockwise3",
	"ClockSnooze",
	"ClockTime",
	"Clone",
	"Clone2",
	"CloneDashed",
	"CloneDashed2",
	"CloneDashed3",
	"CloneImageDashed",
	"ClonePlus",
	"ClonePlus2",
	"CloneVideoDashed",
	"CloneXmark",
	"CloneXmark2",
	"ClosedCaptions",
	"ClosingQuotationMark",
	"ClothesHanger",
	"Cloud",
	"CloudBolt",
	"CloudDownload",
	"CloudDownload2",
	"CloudDroplet",
	"CloudFog",
	"CloudHail",
	"CloudHailMixed",
	"CloudNodes",
	"CloudPlay",
	"CloudRefresh",
	"CloudShowers",
	"CloudSlash",
	"CloudSnow",
	"CloudStreaming",
	"CloudUpload",
	"CloudUpload2",
	"CloudeCode",
	"Clover",
	"Code",
	"Code2",
	"Code3",
	"CodeAction",
	"CodeBranch",
	"CodeCommit",
	"CodeCompare",
	"CodeEditor",
	"CodeFork",
	"CodeMerge",
	"CodePullRequest",
	"CodePullRequestClosed",
	"Coffee",
	"Coin",
	"CoinStack",
	"Coins",
	"Collision",
	"ColorPalette",
	"ColorPalette2",
	"Comb",
	"Command",
	"CompactDisk",
	"Compass",
	"Compass2",
	"Compass3",
	"Compass4",
	"Compass5",
	"Compose",
	"Compose2",
	"Compose3",
	"Computer",
	"ComputerSpeaker",
	"ConditionalLogic",
	"ConferenceRoom",
	"Connect",
	"ConnectPlus",
	"ConnectedDots",
	"ConnectedDots2",
	"ConnectedDots3",
	"ConnectedDots4",
	"Connection",
	"Connection2",
	"Connection3",
	"Connections",
	"Connections2",
	"Connections3",
	"Console",
	"ConstructionCrane",
	"ConstructionSign",
	"Contacts",
	"Contrast",
	"Conversion",
	"Cookie",
	"Copies",
	"Copies2",
	"Copies3",
	"Copies4",
	"Copies5",
	"CopiesPlus",
	"CopiesPlus2",
	"Copy",
	"Copy2",
	"CopyDelete",
	"CopyId",
	"Copyright",
	"CornerRadius",
	"CosmeticJar",
	"Coupon",
	"Cover",
	"CreativeCommons",
	"CreditCard",
	"CreditCardAlert",
	"CreditCardCheck",
	"CreditCardContactless",
	"CreditCardContactless2",
	"CreditCardHeart",
	"CreditCardLock",
	"CreditCardMinus",
	"CreditCardPen",
	"CreditCardPlus",
	"CreditCardReader",
	"CreditCardRefresh",
	"CreditCardSignal",
	"CreditCards",
	"Crop",
	"CropAlphaGrid",
	"CropRotate",
	"Crosshairs",
	"Crosshairs2",
	"Crosshairs2Slash",
	"Crosshairs3",
	"Crosshairs4",
	"Crosshairs5",
	"CrosshairsSlash",
	"Crowd",
	"Crown",
	"Crown2",
	"Cryptography",
	"Cube",
	"Cube2",
	"CubeAxis",
	"CubeFloor",
	"CubeSettings",
	"CubeTransparent",
	"Cubes",
	"Cubes2",
	"CupTogo",
	"CurrencyDollar",
	"CurrencyEuro",
	"CurrencyExchange",
	"CurrencyRupee",
	"CurrencySterling",
	"CurrencyYen",
	"CursorDefault",
	"CursorRays",
	"CursorRipple",
	"Curve",
	"CutlerySlash",
	"Cyborg",
	"Cylinder",
	"DarkLight",
	"DarkMode",
	"DarkModeSparkle",
	"DataSettings",
	"Database",
	"DatabaseCheck",
	"DatabaseCloud",
	"DatabaseExport",
	"DatabaseKey",
	"DatabaseLock",
	"DatabaseMinus",
	"DatabasePen",
	"DatabasePlus",
	"DatabaseSearch",
	"Deaf",
	"Decentralize",
	"DecisionProcess",
	"DeleteLeft",
	"DeleteRight",
	"DependencyLink",
	"DescendingSorting",
	"DesignFile",
	"DesignFileDownload",
	"DesignFileEdit",
	"DesignFileImport",
	"DesignFilePlus",
	"DesignFileSend",
	"DesignFileShared",
	"DeskLamp",
	"DeskNamePlate",
	"DesktopArrowDown",
	"DesktopArrowUp",
	"DesktopDock",
	"DeviceConnection",
	"DeviceMockup",
	"DiagramGantt",
	"DiagramVenn",
	"Dial",
	"DiamondSparkle",
	"DiamondTurnLeft",
	"DiamondTurnRight",
	"Dice",
	"Dice1",
	"Dice2",
	"Dice3",
	"Dice4",
	"Dice5",
	"Dice6",
	"Diet",
	"DietApple",
	"DietCalendar",
	"Directions",
	"DirectionsAll",
	"Discount",
	"DiscountCode",
	"DiscountTag",
	"DividerX",
	"DividerXDotted",
	"DividerY",
	"DividerYDotted",
	"Dna",
	"DoNotWash",
	"Doctor",
	"DocumentScan",
	"Dog",
	"Dog2",
	"DogLeash",
	"DogSlash",
	"DollarValueDown",
	"DollarValueUp",
	"DoorOpen",
	"DotFormation",
	"Dots",
	"DotsVertical",
	"DoubleChevronDown",
	"DoubleChevronLeft",
	"DoubleChevronRight",
	"DoubleChevronUp",
	"Download",
	"Download2",
	"Download3",
	"Download4",
	"DrawCompass",
	"DrawCompass2",
	"DrawFinger",
	"DrawingTablet",
	"Dress",
	"DressShoes",
	"Dresser",
	"DrinkSlash",
	"Drone",
	"DropCap",
	"DropdownList",
	"DropdownList2",
	"DropdownMenu",
	"DropdownSelect",
	"Droplet",
	"DropletSlash",
	"Dumbbell",
	"Duplicate",
	"Duplicate2",
	"DuplicatePlus",
	"DuplicatePlus2",
	"Ear",
	"EarSound",
	"Earphones",
	"Earth",
	"EarthAlert",
	"EarthCheck",
	"EarthCursor",
	"EarthLeaf",
	"EarthLock",
	"EarthPin",
	"EarthPosition",
	"EarthSearch",
	"EarthShield",
	"EaseIn",
	"EaseInOut",
	"EaseOut",
	"Eclipse",
	"EditCircle",
	"EditEasing",
	"EditPolygon",
	"EditSquare",
	"EditSquarePlus",
	"EditTriangle",
	"Egg",
	"EggDecorated",
	"Eggs",
	"Embed",
	"Empty",
	"Engine",
	"EnterDoor",
	"EnterHome",
	"Envelope",
	"EnvelopeAlert",
	"EnvelopeArrowRight",
	"EnvelopeBan",
	"EnvelopeCheck",
	"EnvelopeClip",
	"EnvelopeClock",
	"EnvelopeContent",
	"EnvelopeFeather",
	"EnvelopeHeart",
	"EnvelopeMinus",
	"EnvelopeNotification",
	"EnvelopeOpen",
	"EnvelopeOpenCheck",
	"EnvelopeOpenHeart",
	"EnvelopePen",
	"EnvelopePhone",
	"EnvelopePlus",
	"EnvelopeSparkle",
	"Envelopes",
	"EqualGreaterThan",
	"EqualLessThan",
	"Equalizer",
	"Equalizer2",
	"Equals",
	"Equation",
	"Eraser",
	"EraserSparkle",
	"EscalatorDown",
	"EscalatorUp",
	"Ethereum",
	"ExitDoor",
	"Expand",
	"Expand2",
	"Expand3",
	"ExpandObj",
	"ExpandObj2",
	"ExpandWide",
	"ExplodingHead",
	"Export",
	"Export2",
	"ExternalLink",
	"Eye",
	"Eye2",
	"Eye2Slash",
	"EyeClosed",
	"EyeDashed",
	"EyeDropper",
	"EyeLens",
	"EyeOpen",
	"EyeScanner",
	"EyeSensor",
	"EyeSlash",
	"EyeSparkle",
	"Eyelash",
	"FaceAngry",
	"FaceCheck",
	"FaceCrossedOutEyes",
	"FaceDisappointed",
	"FaceEdit",
	"FaceEnraged",
	"FaceEvil",
	"FaceExpression",
	"FaceGrin",
	"FaceGrin2",
	"FaceGrinClosedEyes",
	"FaceGrinUpsideDown",
	"FaceGrinWink",
	"FaceKiss",
	"FaceKissHeartEyes",
	"FaceLaughing",
	"FaceLaughing2",
	"FaceLossForWords",
	"FaceMelting",
	"FaceMinus",
	"FaceMustache",
	"FaceNauseated",
	"FaceNerd",
	"FaceNerdSmile",
	"FaceNeutral",
	"FacePlus",
	"FacePouting",
	"FaceRobot",
	"FaceRobot2",
	"FaceRobot3",
	"FaceSad",
	"FaceSad2",
	"FaceSearch",
	"FaceSinging",
	"FaceSleeping",
	"FaceSmile",
	"FaceSmile2",
	"FaceSmileClosedEyes",
	"FaceSmileUpsideDown",
	"FaceSmileWink",
	"FaceSpeechlessSweat",
	"FaceSun",
	"FaceSurprise",
	"FaceTongueClosedEyes",
	"FaceTongueWink",
	"FaceWoozy",
	"FaceWorried",
	"FaceWorried2",
	"FaceXmark",
	"FacialRecognition",
	"Fan",
	"FavoriteDownload",
	"Feather",
	"Feather2",
	"Feather2Plus",
	"Feather2Sparkle",
	"FeatherPlus",
	"FerrisWheel",
	"File",
	"FileAlert",
	"FileArrowIn",
	"FileBan",
	"FileBookmark",
	"FileCheck",
	"FileClip",
	"FileClock",
	"FileCloud",
	"FileContent",
	"FileDownload",
	"FileExport",
	"FileFeather",
	"FileHeart",
	"FileKey",
	"FileLink",
	"FileLock",
	"FileMinus",
	"FileMusic",
	"FilePen",
	"FilePlay",
	"FilePlus",
	"FilePointer",
	"FileRefresh",
	"FileReplace",
	"FileSearch",
	"FileSend",
	"FileSettings",
	"FileShield",
	"FileSparkle",
	"FileStar",
	"FileTree",
	"FileUser",
	"FileXmark",
	"FileZip",
	"FileZip2",
	"Files",
	"Files2",
	"FilesContent",
	"Fill",
	"FillLoader",
	"Film",
	"FilmPlay",
	"Filter",
	"Filter2",
	"Filter2Minus",
	"Filter2Off",
	"Filter2Plus",
	"Filter3",
	"FilterMinus",
	"FilterOff",
	"FilterPlus",
	"Filters",
	"FindEdit",
	"FindReplace",
	"Finder",
	"Fingerprint",
	"Fire",
	"FireFlame",
	"Fireworks",
	"Flag",
	"Flag2",
	"Flag3",
	"Flag4",
	"Flag5",
	"Flag6",
	"Flag7",
	"FlagCheckered",
	"FlagMenu",
	"Flame",
	"Flame2",
	"FlameSlash",
	"Flashlight",
	"Flask",
	"FlipFlops",
	"FlipHorizontal",
	"FlipHorizontal2",
	"FlipUpHelmet",
	"FlipVertical",
	"FlipVertical2",
	"FloatLeft",
	"FloatRight",
	"FloppyDisk",
	"Flower",
	"FlowerLotus",
	"Focus",
	"FocusCenter",
	"FocusMode",
	"FocusModeOff",
	"Fog",
	"Folder",
	"Folder2",
	"Folder2Open",
	"Folder3",
	"Folder4",
	"Folder5",
	"Folder5Open",
	"FolderAlert",
	"FolderBan",
	"FolderBolt",
	"FolderBookmark",
	"FolderCheck",
	"FolderClip",
	"FolderClock",
	"FolderCloud",
	"FolderContent",
	"FolderContent2",
	"FolderDots",
	"FolderDownload",
	"FolderFeather",
	"FolderHeart",
	"FolderImport",
	"FolderKey",
	"FolderLink",
	"FolderLock",
	"FolderMinus",
	"FolderMusic",
	"FolderOpen",
	"FolderPen",
	"FolderPlay",
	"FolderPlus",
	"FolderPointer",
	"FolderRefresh",
	"FolderReplace",
	"FolderSearch",
	"FolderSend",
	"FolderSettings",
	"FolderShield",
	"FolderSparkle",
	"FolderStar",
	"FolderTree",
	"FolderUser",
	"FolderXmark",
	"Folders",
	"FollowObjDown",
	"FollowObjDownLeft",
	"FollowObjDownRight",
	"FollowObjLeft",
	"FollowObjRight",
	"FollowObjUp",
	"FollowObjUpLeft",
	"FollowObjUpRight",
	"FoodDeliveryBag",
	"FoodDeliveryBox",
	"FoodDeliveryTime",
	"FoodOrder",
	"FoodScale",
	"Footsteps",
	"Fork",
	"Forklift",
	"Form",
	"Frame",
	"Frame2",
	"Framework",
	"FuelCan",
	"FuelCan2",
	"FullScreen",
	"FullScreen2",
	"FullScreen3",
	"FullScreen4",
	"FxBlur",
	"GameConsoleHandheld",
	"Gamepad",
	"Gamepad2",
	"Gamepad3",
	"Gamepad4",
	"Gamepad5",
	"Gamepad6",
	"GamepadButtons",
	"GamingBlocks",
	"GamingButtons",
	"GanttChart",
	"Gap",
	"GapX",
	"GapY",
	"Garage",
	"GasPump",
	"Gauge",
	"Gauge2",
	"Gauge3",
	"Gauge4",
	"Gauge5",
	"Gauge6",
	"Gauge7",
	"Gavel",
	"Gear",
	"Gear2",
	"Gear3",
	"Gear3Sparkle",
	"Gear4",
	"GearArrowRight",
	"GearKeyhole",
	"GearNodes",
	"Gears",
	"Gem",
	"GemSparkle",
	"Ghost",
	"GhostEnraged",
	"GhostGrin",
	"GhostSinging",
	"GhostWorried",
	"Gif",
	"Gift",
	"Gift2",
	"Gift3",
	"Gift4",
	"GiftCard",
	"Glass",
	"GlassJuice",
	"Glasses",
	"Glasses2",
	"GlassesHeart",
	"Globe",
	"Globe2",
	"Globe3",
	"GlobeLock",
	"GlobePointer",
	"GlobeSearch",
	"GoGlobal",
	"GoalFlag",
	"GoldBars",
	"GolfFlag",
	"Gradient",
	"GraduationCap",
	"GreaterThan",
	"GreekTemple",
	"GreekTemple2",
	"Grid",
	"Grid2",
	"Grid2x2",
	"Grid3",
	"Grid3x3",
	"Grid4x4",
	"GridCheck",
	"GridCircle",
	"GridCircleList",
	"GridCirclePlus",
	"GridDots",
	"GridEmptyObjBottomLeft",
	"GridEmptyObjBottomRight",
	"GridLayout",
	"GridLayout10",
	"GridLayout11",
	"GridLayout2",
	"GridLayout3",
	"GridLayout4",
	"GridLayout5",
	"GridLayout6",
	"GridLayout7",
	"GridLayout8",
	"GridLayout9",
	"GridLayoutCols",
	"GridLayoutCols3",
	"GridLayoutRows",
	"GridLayoutRows3",
	"GridList",
	"GridObjSnapToBottomLeft",
	"GridObjSnapToBottomRight",
	"GridObjSnapToTopLeft",
	"GridObjSnapToTopRight",
	"GridPlus",
	"GridPlus2",
	"GridRectCircle",
	"GridSearch",
	"GridSparkle",
	"GridSquareCirclePlus",
	"GridSystem",
	"GridSystem2",
	"GripDots",
	"GripDotsVertical",
	"GroundPlaneDetection",
	"GymBag",
	"HailMixed",
	"HairDryer",
	"HalfDashedCirclePlay",
	"HalfDottedCircleOne",
	"HalfDottedCirclePause",
	"HalfDottedCirclePlay",
	"HalfDottedCircleStop",
	"Hammer",
	"Hammer2",
	"Hand",
	"Hand2",
	"Hand2Ban",
	"Hand2Shield",
	"Hand3",
	"HandBookOpen",
	"HandCheck",
	"HandCheck2",
	"HandCube",
	"HandHoldingBox",
	"HandHoldingCoin",
	"HandHoldingCoin2",
	"HandHoldingGift",
	"HandHoldingGlobe",
	"HandHoldingHeart",
	"HandHoldingKey",
	"HandHoldingMedicine",
	"HandPointer",
	"HandPointingCube",
	"HandTruck",
	"HandWave",
	"HandWave2",
	"HandsHeart",
	"Handshake",
	"Handshake2",
	"Haptic",
	"HardDrive",
	"Hashtag",
	"HatBeanie",
	"HatSanta",
	"HeadFrontVrHeadset",
	"HeadSideVrHeadset",
	"Heading1",
	"Heading2",
	"Heading3",
	"Heading4",
	"Heading5",
	"Heading6",
	"Headphones",
	"Headphones2",
	"Headphones3",
	"Headphones4",
	"Headset",
	"Heart",
	"Heart2",
	"Heart2Broken",
	"Heart2Half",
	"Heart2List",
	"Heart2Lock",
	"Heart2Minus",
	"Heart2Plus",
	"Heart2Slash",
	"Heart2Sparkle",
	"Heart2User",
	"HeartBroken",
	"HeartHalf",
	"HeartHand",
	"HeartHands",
	"HeartHandshake",
	"HeartList",
	"HeartLock",
	"HeartMinus",
	"HeartPlus",
	"HeartPulse",
	"HeartSlash",
	"HeartSparkle",
	"HeartUser",
	"Hearts",
	"Hearts2",
	"HeightMax",
	"HeightMin",
	"Helicopter",
	"Helmet",
	"HelpChat",
	"Hexadecagon",
	"HexadecagonStar",
	"HexagonCheck",
	"HexagonImage",
	"HexagonSparkle",
	"HexagonUser",
	"Hexagons",
	"HighDefinition",
	"HighHeelsShoes",
	"Highlighter",
	"Highlighter2",
	"Hiking",
	"HistogramAxisX",
	"History",
	"History2",
	"HorseHead",
	"Hospital",
	"HotDrink",
	"Hotspot",
	"HotspotOff",
	"Hourglass",
	"HourglassClock",
	"HourglassEnd",
	"HourglassStart",
	"Hours24",
	"House",
	"House2",
	"House3",
	"House4",
	"House5",
	"House6",
	"House7",
	"House8",
	"House9",
	"HouseAlert",
	"HouseBolt",
	"HouseBookmark",
	"HouseCloud",
	"HouseDashboard",
	"HouseDashboard2",
	"HouseDollarSign",
	"HouseDots",
	"HouseGrin",
	"HouseHeart",
	"HouseLink",
	"HouseLock",
	"HouseMinus",
	"HouseMinus2",
	"HouseModern",
	"HouseModern2",
	"HouseModern3",
	"HouseModern4",
	"HousePen",
	"HousePin",
	"HousePlus",
	"HouseSearch",
	"HouseSettings",
	"HouseShield",
	"HouseSparkle",
	"HouseStar",
	"HouseUser",
	"HouseUser2",
	"Humidity",
	"Humidity2",
	"Icosahedron",
	"IdBadge",
	"IdBadge2",
	"Image",
	"ImageBinary",
	"ImageDepth",
	"ImageDepthSparkle",
	"ImageMinus",
	"ImageMountain",
	"ImageMountain2",
	"ImagePlus",
	"ImageScale",
	"ImageSparkle",
	"ImageSparkle2",
	"ImageSparkle3",
	"ImageUpscale",
	"Images",
	"Images2",
	"Images3",
	"Img4k",
	"ImmersiveSlider",
	"Import",
	"Inbox",
	"InboxArrowDown",
	"InboxArrowUp",
	"InboxStack",
	"Incognito",
	"IndentDecrease",
	"IndentDecrease2",
	"IndentIncrease",
	"IndentIncrease2",
	"Industry",
	"Infinity",
	"InputField",
	"InputPassword",
	"InputPasswordAlert",
	"InputPasswordCheck",
	"InputPasswordEdit",
	"InputPasswordPointer",
	"InputPasswordSettings",
	"InputPasswordXmark",
	"InputSearch",
	"InsertCrypto",
	"InsertDollar",
	"Install",
	"Install2",
	"InstantMoney",
	"Intersection",
	"Interview",
	"Investment",
	"Investment2",
	"Investment3",
	"Invoice",
	"InvoiceDollar",
	"InvoiceIn",
	"InwardFlow",
	"Iron",
	"IronDoNot",
	"IsolatedCube",
	"Itinerary",
	"Itinerary2",
	"Itinerary3",
	"Itinerary4",
	"Itinerary5",
	"JackOLantern",
	"Jewel",
	"JoinedHands",
	"Joystick",
	"Joystick2",
	"Judge",
	"JudgementNegative",
	"JudgementPositive",
	"Key",
	"Key2",
	"Key3",
	"Key4",
	"KeyNodes",
	"Keyboard",
	"Keyboard2",
	"Keyboard2Cable",
	"Keyboard2HideDown",
	"Keyboard2Mouse",
	"Keyboard2Wireless",
	"Keyboard3",
	"Keyboard4",
	"Keyboard4Cable",
	"Keyboard4HideDown",
	"Keyboard4Mouse",
	"Keyboard4Wireless",
	"KeyboardCable",
	"KeyboardHideDown",
	"KeyboardMouse",
	"KeyboardWireless",
	"KeysLeftRight",
	"KeysUpDown",
	"KickScooter",
	"KickScooterElectric",
	"KnifeFork",
	"KnifeSpoon",
	"Label",
	"Label2",
	"Label2Check",
	"Label2Minus",
	"Label2Plus",
	"Label2Slash",
	"Label3",
	"LabelInfo",
	"LabelMinus",
	"LabelPlus",
	"Language",
	"Laptop",
	"Laptop2",
	"Laptop3",
	"LaptopChartCols",
	"LaptopChartLine",
	"LaptopChartPie",
	"LaptopMobile",
	"LaptopVideo",
	"Lasso",
	"LassoSparkle",
	"LawShield",
	"LayerBack",
	"LayerDown",
	"LayerFront",
	"LayerReplace",
	"LayerUp",
	"Layers",
	"Layers2",
	"Layers3",
	"LayersMinus",
	"LayersPlus",
	"LayersStacked",
	"LayoutBottom",
	"LayoutFooter",
	"LayoutHeader",
	"LayoutLeft",
	"LayoutMainContent",
	"LayoutMoveToBottom",
	"LayoutMoveToLeft",
	"LayoutMoveToRight",
	"LayoutMoveToTop",
	"LayoutRight",
	"LayoutSidebar",
	"LayoutTop",
	"Leaf",
	"Lectern",
	"Lectern2",
	"LessThan",
	"LetterSpacing",
	"Levels",
	"License",
	"LifeRing",
	"LightSpark",
	"LightSpark2",
	"LightSwitch",
	"Lightbulb",
	"Lightbulb2",
	"Lightbulb3",
	"LightbulbSparkle",
	"LineDashed",
	"LineHeight",
	"LineSpacing",
	"LinesY",
	"LinesY2",
	"Link",
	"Link2",
	"Link2Slash",
	"Link3",
	"Link4",
	"Link4Slash",
	"Link5",
	"Link5Slash",
	"LinkBroken",
	"LinkMinus",
	"LinkPlus",
	"LinkSlash",
	"Lips",
	"Lipstick",
	"ListCheckbox",
	"ListCheckbox2",
	"ListExport",
	"ListFavs",
	"ListFavs2",
	"ListFavs3",
	"ListFavs4",
	"ListMultipleChoice",
	"ListRadio",
	"ListTodo",
	"ListTree",
	"Live",
	"LiveOff",
	"Loader",
	"Loader2",
	"Loader3",
	"Loader4",
	"Loader5",
	"Loader6",
	"LoadingStatus",
	"LoadingStatus2",
	"Location",
	"Location2",
	"Location3",
	"Location4",
	"Location5",
	"Location6",
	"Lock",
	"LockCircle",
	"LockCircleOpen",
	"LockCircleOpen2",
	"LockKey",
	"LockOpen",
	"LockOpen2",
	"LockPassword",
	"LockedChat",
	"Logo",
	"MachineWash",
	"MagicHat",
	"MagicRabbit",
	"MagicShield",
	"MagicWand",
	"MagicWandSparkle",
	"Magnet",
	"MagnetBolt",
	"Magnifier",
	"Magnifier2",
	"Magnifier3",
	"MagnifierAlert",
	"MagnifierAlert2",
	"MagnifierCheck",
	"MagnifierFaceGrin",
	"MagnifierFaceWorried",
	"MagnifierHistory",
	"MagnifierMinus",
	"MagnifierPlus",
	"MagnifierSlash",
	"MagnifierSparkle",
	"MagnifierSparkle2",
	"MagnifierStar",
	"MagnifierStar2",
	"Mailbox",
	"MakeupBrush",
	"MakeupCream",
	"Map",
	"MapAlert",
	"MapCheck",
	"MapClock",
	"MapCursor",
	"MapDownload",
	"MapHeart",
	"MapLink",
	"MapLock",
	"MapMinus",
	"MapPen",
	"MapPin",
	"MapPlus",
	"MapPosition",
	"MapRefresh",
	"MapSearch",
	"MapSettings",
	"MapStar",
	"MapXmark",
	"Markdown",
	"MarketingTarget",
	"Mars",
	"MaskCircle",
	"MaskRect",
	"Material",
	"Material2",
	"MathFunction",
	"MaximizeWindow",
	"Measure",
	"Medal",
	"MediaEject",
	"MediaFastBackwards",
	"MediaFastForward",
	"MediaLibrary",
	"MediaLibrary2",
	"MediaNext",
	"MediaPause",
	"MediaPlay",
	"MediaPlayPauseToggle",
	"MediaPlaylist",
	"MediaPrevious",
	"MediaRecord",
	"MediaSkipToEnd",
	"MediaSkipToStart",
	"MediaStop",
	"MedicalMask",
	"Medicine",
	"Megaphone",
	"Membership",
	"Memories",
	"Menu",
	"Menu2",
	"Menu3",
	"Menu4",
	"MenuArrowLeft",
	"MenuArrowRight",
	"MenuBars",
	"MenuLeft",
	"MenuLeft2",
	"MenuRight",
	"MenuRight2",
	"Merge",
	"Merge2",
	"Merge3",
	"Message",
	"MessageArrowRight",
	"MessageBubbleUser",
	"MessageCheck",
	"MessageClip",
	"MessageClock",
	"MessageContent",
	"MessageFlag",
	"MessageForward",
	"MessageHeart",
	"MessageLock",
	"MessagePen",
	"MessagePlus",
	"MessageQuote",
	"MessageSmile",
	"MessageSparkle",
	"MessageStar",
	"MessageUser",
	"MessageWriting",
	"Messages",
	"Microchip",
	"Microphone",
	"Microphone2",
	"Microphone2Slash",
	"Microphone3",
	"Microphone3Off",
	"MicrophoneSlash",
	"Microscope",
	"MilitaryMedal",
	"MinimizeWindow",
	"Minus",
	"MirrorObj",
	"MirrorObjX",
	"MirrorObjXDotted",
	"MirrorObjY",
	"MirrorObjYDotted",
	"Mobile",
	"Mobile2",
	"MobileCircuit",
	"MobileHeart",
	"MobileSignal",
	"MobileWave",
	"MobileWave2",
	"Molecule",
	"Money",
	"MoneyBill",
	"MoneyBill2",
	"MoneyBillCoin",
	"MoneyBills",
	"MoneyBills2",
	"MoneyBillsDollar",
	"MoneyDollar",
	"MoneyRefund",
	"MoneyRefund2",
	"MoneyTransfer",
	"Monitor",
	"MonitorSettings",
	"MonitorVideo",
	"Moon",
	"MoonCloud",
	"MoonCloudBolt",
	"MoonCloudDroplet",
	"MoonCloudFog",
	"MoonCloudHail",
	"MoonCloudHailMixed",
	"MoonCloudShowers",
	"MoonCloudSnow",
	"MoonFog",
	"MoonFull",
	"MoonStars",
	"MortarPestle",
	"MotionAlongPath",
	"Mouse",
	"Mouse2",
	"MouseCable",
	"MouseScroll",
	"MouseScrollDown",
	"MoveObjDown",
	"MoveObjDown2",
	"MoveObjDownLeft",
	"MoveObjDownRight",
	"MoveObjLeft",
	"MoveObjRight",
	"MoveObjUp",
	"MoveObjUp2",
	"MoveObjUpLeft",
	"MoveObjUpRight",
	"MoveToBottom",
	"MoveToLeft",
	"MoveToRight",
	"MoveToTop",
	"Movie",
	"MovieReel",
	"Msg",
	"Msg2",
	"MsgArrowRight",
	"MsgBubbleUser",
	"MsgCheck",
	"MsgClip",
	"MsgClock",
	"MsgContent",
	"MsgDotted",
	"MsgFlag",
	"MsgForward",
	"MsgHeart",
	"MsgLock",
	"MsgPen",
	"MsgPlus",
	"MsgQuote",
	"MsgSleep",
	"MsgSmile",
	"MsgSmile2",
	"MsgSparkle",
	"MsgStar",
	"MsgUser",
	"MsgWriting",
	"Msgs",
	"Msgs2",
	"Mug",
	"Mug2",
	"Music",
	"MusicAlbum",
	"MusicNote",
	"MusicNote2",
	"MusicNote2Plus",
	"MusicNote2Sparkle",
	"MusicNoteSlash",
	"MusicNoteSparkle",
	"MusicPlaylist",
	"MusicPlaylist2",
	"MusicPlus",
	"Mustache",
	"Nail",
	"NamePlate",
	"Navigation",
	"NavigationHorizontal",
	"NavigationVertical",
	"Necktie",
	"Necktie2",
	"Newspaper",
	"Newspaper2",
	"NightMode",
	"NightModeOff",
	"NightShift",
	"Nodes",
	"Nodes2",
	"Nodes3",
	"Nodes4",
	"NotEqual",
	"Note",
	"Note2",
	"Note3",
	"Notebook",
	"NotebookBookmark",
	"NotebookClock",
	"Notepad",
	"Notes",
	"Notification",
	"NumberInput",
	"Numbers",
	"Nut",
	"Nut2",
	"Obj3dBack",
	"Obj3dFront",
	"ObjAdd",
	"ObjIncreaseSizeX",
	"ObjIncreaseSizeY",
	"ObjReduceSizeX",
	"ObjReduceSizeY",
	"ObjRemove",
	"ObjSizeIncrease",
	"ObjSizeIncreaseX",
	"ObjSizeIncreaseY",
	"ObjSizeReduce",
	"ObjSizeReduceX",
	"ObjSizeReduceY",
	"ObjectSelection",
	"ObjsGroup",
	"ObjsUngroup",
	"OctagonCheck",
	"OctagonInfo",
	"OctagonQuestion",
	"OctagonUser",
	"OctagonWarning",
	"Office",
	"Office2",
	"Office3",
	"OfficeUser",
	"OilCan",
	"OilCanDrop",
	"OpenCircleBolt",
	"OpenExternal",
	"OpenInBrowser",
	"OpenInNewWindow",
	"OpenRectArrowIn",
	"OpenRectArrowOut",
	"OpeningQuotationMark",
	"Orange",
	"OrbitSparkle",
	"OrderedList",
	"OrderedList2",
	"OrganizeObjs",
	"OrientationLandscape",
	"OrientationPortrait",
	"OutwardFlow",
	"Page",
	"Page2",
	"PaintRoller",
	"PaintRoller2",
	"Paintbrush",
	"Palette",
	"Palette2",
	"Pallet",
	"PalletPackage",
	"Panorama",
	"PanoramaImage",
	"PaperPlane",
	"PaperPlane2",
	"PaperPlane3",
	"PaperPlane4",
	"PaperPlane4Clock",
	"PaperPlane4Link",
	"PaperPlaneFast",
	"Paperclip",
	"Paperclip2",
	"PaperclipMinus",
	"PaperclipPlus",
	"Parachute",
	"Paragraph",
	"ParagraphAdd",
	"ParagraphCheck",
	"ParagraphClear",
	"ParagraphSpacing",
	"ParkingSensor",
	"ParkingSign",
	"Party",
	"Passport",
	"Password",
	"Password2",
	"Patch",
	"Patches",
	"Path",
	"Path2",
	"Paw",
	"Peace",
	"Pen",
	"Pen2",
	"Pen3",
	"PenArrowClockwise",
	"PenDraw",
	"PenDrawSparkle",
	"PenNib",
	"PenNib2",
	"PenNib3",
	"PenPlus",
	"PenSparkle",
	"PenWriting",
	"PenWriting2",
	"PenWriting3",
	"PenWriting4",
	"PenWriting5",
	"PenWriting6",
	"PenWriting7",
	"PenWriting8",
	"Pencil",
	"Pencil2",
	"Pendulum",
	"People",
	"People2",
	"People3",
	"PeopleAlert",
	"PeopleRoof",
	"Percentage",
	"PercentageArrowDown",
	"PercentageArrowUp",
	"Perfume",
	"Person",
	"PersonArrowDown",
	"PersonArrowUp",
	"PersonBiking",
	"PersonCane",
	"PersonDelivery",
	"PersonDoor",
	"PersonDress",
	"PersonDressArrowDown",
	"PersonDressArrowUp",
	"PersonJumpingRope",
	"PersonWalking",
	"PersonWheelchair",
	"Phone",
	"PhoneCallCross",
	"PhoneCallForward",
	"PhoneCallIncoming",
	"PhoneCallOutgoing",
	"PhoneCheck",
	"PhoneDots",
	"PhoneModern",
	"PhoneMsg",
	"PhoneOffice",
	"PhoneOld",
	"PhoneOld2",
	"PhonePlus",
	"PhoneRotary",
	"PhoneSlash",
	"PhoneVolume",
	"Photo",
	"PhotoAlbum",
	"PhotoEditor",
	"PhotoFrame",
	"PhotoMinus",
	"PhotoPlus",
	"Photos",
	"Pickaxe",
	"PicnicTable",
	"PictInPictBottomLeft",
	"PictInPictBottomRight",
	"PictInPictTopLeft",
	"PictInPictTopRight",
	"PiggyBank",
	"Pilcrow",
	"PileOfPoo",
	"Pillow",
	"Pin",
	"PinA",
	"PinB",
	"PinCheck",
	"PinClock",
	"PinHeart",
	"PinLink",
	"PinLock",
	"PinMinus",
	"PinPen",
	"PinPlus",
	"PinRefresh",
	"PinSearch",
	"PinSettings",
	"PinSlash",
	"PinStar",
	"PinTack",
	"PinTack2",
	"PinTackSlash",
	"Pins",
	"Pins2",
	"Pinwheel",
	"PivotTable",
	"Pizza",
	"PizzaSlice",
	"PizzaSlice2",
	"Plane",
	"Plane2",
	"PlaneLanding",
	"PlaneSlash",
	"PlaneTakeOff",
	"Planet",
	"PlayRotateClockwise",
	"PlayRotateClockwise2",
	"Playground",
	"Playlist",
	"Playlist2",
	"Playlist3",
	"Playlist4",
	"Plug",
	"Plug2",
	"Plug3",
	"Plug3Sparkle",
	"PlugOff",
	"PlugSensor",
	"PlugSparkle",
	"Plus",
	"Podcast",
	"Pointer",
	"PointerCircle",
	"Pop",
	"PopEffect",
	"PortalSparkle",
	"Pos",
	"Pos2",
	"PositionBottom",
	"PositionBottomLeft",
	"PositionBottomRight",
	"PositionCenter",
	"PositionLeft",
	"PositionRight",
	"PositionTop",
	"PositionTopLeft",
	"PositionTopRight",
	"Post",
	"Post2",
	"PostageStamp",
	"Potion",
	"PowerLevel",
	"PowerLightning",
	"PowerOff",
	"Presentation",
	"PresentationScreen",
	"PresentationScreenChartCols",
	"PresentationScreenChartLine",
	"PresentationScreenChartPie",
	"PresentationScreenCheck",
	"PresentationScreenLink",
	"PresentationScreenMinus",
	"PresentationScreenPlay",
	"PresentationScreenPlus",
	"PresentationScreenSparkle",
	"PresentationScreenVideo",
	"Print",
	"Print2",
	"PriorityHigh",
	"PriorityHigh2",
	"PriorityHighest",
	"PriorityLow",
	"PriorityLow2",
	"PriorityLowest",
	"PriorityMedium2",
	"PriorityNormal",
	"ProfileAnalytics",
	"ProfileBasic",
	"Profiles",
	"Profiles2",
	"ProgressBar",
	"ProgressCircle0Of4",
	"ProgressCircle0Of8",
	"ProgressCircle1Of4",
	"ProgressCircle1Of8",
	"ProgressCircle2Of4",
	"ProgressCircle2Of8",
	"ProgressCircle3Of4",
	"ProgressCircle3Of8",
	"ProgressCircle4Of4",
	"ProgressCircle4Of8",
	"ProgressCircle5Of8",
	"ProgressCircle6Of8",
	"ProgressCircle7Of8",
	"ProgressCircle8Of8",
	"ProgressIndicator",
	"ProgressIndicator2",
	"Promotion",
	"Prototype",
	"Purse",
	"PuzzlePiece",
	"Pyramid",
	"Qrcode",
	"Queue",
	"QuickAccess",
	"QuickActions",
	"QuickSearch",
	"QuickTimer",
	"Quickstart",
	"Quote",
	"Rabbit",
	"Radar",
	"Radar2",
	"Radio",
	"RadioChecked",
	"RadioOff",
	"RadioUnchecked",
	"Rainbow",
	"RainbowCloud",
	"Raindrops",
	"Ram",
	"Ranking",
	"RankingStar",
	"Reading",
	"Receipt",
	"Receipt2",
	"Receipt3",
	"Receipt4",
	"Record",
	"RectArrowDown",
	"RectArrowDownLeft",
	"RectArrowDownRight",
	"RectArrowLeft",
	"RectArrowRight",
	"RectArrowUp",
	"RectArrowUpLeft",
	"RectArrowUpRight",
	"RectCenterX",
	"RectCenterY",
	"RectLayoutGrid",
	"RectLayoutGrid2",
	"RectLayoutGrid3",
	"RectLayoutGrid4",
	"RectLayoutGrid5",
	"RectLogin",
	"RectLogout",
	"Recycle",
	"Redo",
	"Redo2",
	"Redo3",
	"Reduce",
	"Reduce2",
	"Refresh",
	"Refresh2",
	"Refresh3",
	"Refresh3AnticlockwiseSlash",
	"Refresh3ClockwiseSlash",
	"RefreshAnticlockwise",
	"RefreshAnticlockwiseSlash",
	"RefreshClockwise",
	"RefreshClockwiseSlash",
	"Refrigerator",
	"RemoteControl",
	"RemoteControl2",
	"Rename",
	"Repeat",
	"Repeat2",
	"Repeat3",
	"Repeat4",
	"RepeatOnce",
	"ReplaceObjs",
	"Report",
	"ReportFile",
	"Reposition",
	"Rerouting",
	"ResizeX",
	"ResizeY",
	"RestaurantMenu",
	"ReturnKey",
	"Reuse",
	"ReusePlus",
	"Ring",
	"Rings",
	"Rings2",
	"Road",
	"Roadmap",
	"Roadmap2",
	"Robot",
	"Robot2",
	"Robot3",
	"Robot4",
	"RoboticArm",
	"RockOn",
	"Rocket",
	"RollerBlade",
	"RopeStanchions",
	"RotateCube",
	"RotateImageAnticlockwise",
	"RotateImageClockwise",
	"RotateObjAnticlockwise",
	"RotateObjClockwise",
	"Rotation360",
	"Rotation3602",
	"Route",
	"RouteAlert",
	"RouteClosed",
	"RouteOpen",
	"Router",
	"RowsOffsetLeft",
	"RowsOffsetRight",
	"Ruler",
	"RulerCursor",
	"RulerPen",
	"RulerPen2",
	"RulerTriangle",
	"Sack",
	"SackCoins",
	"SackDollar",
	"SafetyHelmet",
	"Sailboat",
	"Satellite",
	"SatelliteDish",
	"SavedItems",
	"SavedItems2",
	"Scale",
	"ScaleFromBottomLeft",
	"ScaleFromBottomLeft2",
	"ScaleFromBottomRight",
	"ScaleFromBottomRight2",
	"ScaleFromTopLeft",
	"ScaleFromTopLeft2",
	"ScaleFromTopRight",
	"ScaleFromTopRight2",
	"ScaleImg4k",
	"ScaleUnbalanced",
	"ScaleUnbalanced2",
	"Scan",
	"ScanCode",
	"ScanCube",
	"ScanImage",
	"ScanLock",
	"ScanText",
	"Scarf",
	"School",
	"Scissors",
	"ScissorsComb",
	"ScissorsCoupon2",
	"ScissorsSparkle",
	"Scooter",
	"ScooterDelivery",
	"ScooterFront",
	"ScreenReader",
	"ScreenReader2",
	"ScreenSharing",
	"ScreenSharingOff",
	"Scribble",
	"Scroll",
	"ScrollText",
	"ScrollX",
	"ScrollY",
	"SearchArea",
	"SearchChart",
	"SearchContent",
	"SearchContent2",
	"Seatbelt",
	"Section",
	"SectionTestimonial",
	"Seedling",
	"Select",
	"SelectArea",
	"SelectDropdown",
	"SelectNew",
	"SelectObj",
	"SelectSpeaker",
	"SeparateX",
	"SeparateY",
	"Server",
	"SettingsWrench",
	"Shadow",
	"Shadow2",
	"Shadow3",
	"ShakaHand",
	"ShapeCircle",
	"ShapeCustom",
	"ShapeLine",
	"ShapePolygon",
	"ShapeRectangle",
	"ShapeSquare",
	"ShapeTriangle",
	"Shapes",
	"Shapes2",
	"ShareAllLeft",
	"ShareAllRight",
	"ShareLeft",
	"ShareLeft2",
	"ShareLeft3",
	"ShareLeft4",
	"ShareRight",
	"ShareRight2",
	"ShareRight3",
	"ShareRight4",
	"ShareUpLeft",
	"ShareUpLeft2",
	"ShareUpRight",
	"ShareUpRight2",
	"Sharing",
	"SharkWater",
	"Shield",
	"Shield2",
	"ShieldAlert",
	"ShieldCheck",
	"ShieldGlobe",
	"ShieldHalved",
	"ShieldKey",
	"ShieldKeyhole",
	"ShieldLock",
	"ShieldSlash",
	"ShieldUser",
	"Ship",
	"ShippingContainer",
	"Shirt",
	"ShirtSport",
	"ShoeSneakers",
	"Shop",
	"Shopping",
	"Shovel",
	"Showers",
	"Shuffle",
	"Shuffle2",
	"ShuffleSparkle",
	"SideProfile",
	"SideProfile2",
	"SideProfileConnection",
	"SideProfileHeart",
	"SideProfileQuestion",
	"SideProfileSparkle",
	"SidebarEdit",
	"SidebarLeft",
	"SidebarLeft2",
	"SidebarLeft2Hide",
	"SidebarLeft2Show",
	"SidebarLeft3",
	"SidebarLeft3Hide",
	"SidebarLeft4",
	"SidebarLeft4Hide",
	"SidebarLeft4Show",
	"SidebarLeft5Hide",
	"SidebarLeftHide",
	"SidebarLeftShow",
	"SidebarRight",
	"SidebarRight2",
	"SidebarRight3",
	"SidebarRight3Hide",
	"SidebarRight4",
	"SidebarRight4Hide",
	"SidebarRight4Show",
	"SidebarRight5Hide",
	"SidebarRightHide",
	"SidebarRightShow",
	"Signal",
	"Signal2",
	"Signal2Off",
	"SignalOff",
	"Signature",
	"Signature2",
	"Signature3",
	"Signboard",
	"SignboardCheck",
	"Siren",
	"Sitemap",
	"Sitemap2",
	"Sitemap3",
	"Sitemap4",
	"Sitemap5",
	"Size",
	"SizeLg",
	"SizeMd",
	"SizeSm",
	"Skateboarding",
	"Skull",
	"SlashCircle",
	"SleepingTime",
	"Slice",
	"Slider",
	"Sliders",
	"Sliders2",
	"Sliders2Vertical",
	"Sliders3",
	"Sliders3Vertical",
	"Sliders4",
	"SlidersVertical",
	"Slideshow",
	"Slippers",
	"SloMo",
	"Smoking",
	"SmokingBan",
	"Snail",
	"Sneeze",
	"Snowflake",
	"SoapDispenser",
	"SoccerGoal",
	"SoccerGoal2",
	"SoccerPitch",
	"SocialDistancing",
	"Socks",
	"Sofa",
	"SolarPanel",
	"SortAlphaAscending",
	"SortAlphaDescending",
	"SortArrows",
	"SortBottomToMiddle",
	"SortBottomToTop",
	"SortBottomToTop2",
	"SortDateAscending",
	"SortDateDescending",
	"SortDown",
	"SortMiddleToBottom",
	"SortMiddleToTop",
	"SortNumAscending",
	"SortNumDescending",
	"SortObjBottomToTop",
	"SortObjTopToBottom",
	"SortTopToBottom",
	"SortTopToBottom2",
	"SortTopToMiddle",
	"SortUp",
	"SortVertical",
	"Sorting",
	"Space3d",
	"SpaceX",
	"SpaceY",
	"Spaceship",
	"Sparkle",
	"Sparkle2",
	"Sparkle3",
	"Sparkle4",
	"Spatial",
	"Speaker",
	"Speedometer",
	"Speedometer2",
	"SpellCheck",
	"Sphere",
	"Sphere2",
	"Spider",
	"SpiderWeb",
	"Spiral",
	"Split",
	"Split2",
	"Split3",
	"SplitObjX",
	"SplitObjY",
	"SplitThreeWays",
	"SplitVideo",
	"SplitView",
	"Spoon",
	"SprayCan",
	"SquareActivityChart",
	"SquareArrowDown",
	"SquareArrowDownLeft",
	"SquareArrowDownLeft2",
	"SquareArrowDownRight",
	"SquareArrowDownRight2",
	"SquareArrowLeft",
	"SquareArrowRight",
	"SquareArrowUp",
	"SquareArrowUpLeft",
	"SquareArrowUpLeft2",
	"SquareArrowUpRight",
	"SquareArrowUpRight2",
	"SquareBars",
	"SquareBolt",
	"SquareBracketsCurly",
	"SquareBulletList",
	"SquareCaretDown",
	"SquareCaretLeft",
	"SquareCaretRight",
	"SquareCaretUp",
	"SquareChart",
	"SquareChart2",
	"SquareChartBookmark",
	"SquareChartHeart",
	"SquareChartLine",
	"SquareChartLine2",
	"SquareChartLock",
	"SquareChartMinus",
	"SquareChartPen",
	"SquareChartPlus",
	"SquareChartSearch",
	"SquareChartSettings",
	"SquareChartShared",
	"SquareCheck3",
	"SquareChevronDown",
	"SquareChevronLeft",
	"SquareChevronRight",
	"SquareChevronUp",
	"SquareCircle",
	"SquareCircleGroup",
	"SquareCode",
	"SquareCommand",
	"SquareDashed",
	"SquareDashedContent",
	"SquareDashedCursor",
	"SquareDashedDownload",
	"SquareDashedMinus",
	"SquareDashedPlus",
	"SquareDashedPlus2",
	"SquareDashedSearchSparkle",
	"SquareDashedSparkle",
	"SquareDashedText",
	"SquareDashedTextMinus",
	"SquareDashedTextPlus",
	"SquareDashedTextXmark",
	"SquareDashedUpload",
	"SquareDots",
	"SquareDotsVertical",
	"SquareDotted",
	"SquareDottedArrowBottomLeft",
	"SquareDottedArrowBottomRight",
	"SquareDottedArrowTopLeft",
	"SquareDottedArrowTopRight",
	"SquareExpand",
	"SquareGrid",
	"SquareGrid2",
	"SquareGrid3",
	"SquareGridDots",
	"SquareInfo",
	"SquareKanban",
	"SquareKanban2",
	"SquareLayoutGrid",
	"SquareLayoutGrid2",
	"SquareLayoutGrid3",
	"SquareLayoutGrid4",
	"SquareLayoutGrid5",
	"SquareLayoutGrid6",
	"SquareLock",
	"SquareMenu",
	"SquareMinus",
	"SquareMinus2",
	"SquareMoveObjDownLeft",
	"SquareMoveObjDownRight",
	"SquareMoveObjUpLeft",
	"SquareMoveObjUpRight",
	"SquareNumberOne",
	"SquareNut",
	"SquarePaintbrush",
	"SquarePath",
	"SquarePlay",
	"SquarePlus",
	"SquarePlus2",
	"SquarePlusMinus",
	"SquarePointer",
	"SquareQuestion",
	"SquareSettings",
	"SquareSliders",
	"SquareSparkle",
	"SquareStreaming",
	"SquareTable",
	"SquareTerminal",
	"SquareTimeline",
	"SquareUser",
	"SquareUserMinus",
	"SquareUserPlus",
	"SquareUserSparkle",
	"SquareUserSparkle2",
	"SquareWandSparkle",
	"SquareWarning",
	"SquareXmark",
	"SquaresConnected",
	"Stack",
	"Stack2",
	"Stack2Plus",
	"Stack3",
	"Stack3Plus",
	"StackPerspective",
	"StackPerspective2",
	"StackPerspective3",
	"StackX",
	"StackX2",
	"StackX3",
	"StackXPlus",
	"StackY",
	"StackY2",
	"StackY3",
	"StackYPlus",
	"Stadium",
	"Stage",
	"Stairs",
	"Stamp",
	"Star",
	"Star2",
	"Star2Slash",
	"StarHalf",
	"StarHalf2",
	"StarHand",
	"StarList",
	"StarLock",
	"StarMinus",
	"StarPlus",
	"StarSlash",
	"StarSparkle",
	"StarSparkle2",
	"StarTrail",
	"StarUpgrade",
	"StarUser",
	"Stars",
	"Stars2",
	"SteeringWheel",
	"StepsIndicator",
	"Sticker",
	"StickerSmile",
	"StickerSquare",
	"StillRings",
	"StopSign",
	"Stopwatch",
	"StopwatchBolt",
	"Storage",
	"StorageUnit",
	"Storehouse",
	"Strategy",
	"StringContains",
	"StringDoesNotContain",
	"StringEndsWith",
	"StringStartsWith",
	"StrokeButCap",
	"StrokeProjectingCap",
	"StrokeRoundCap",
	"Student",
	"Style",
	"Subscript",
	"Subscription",
	"Subscription2",
	"Subtitles",
	"Subtitles2",
	"SuitClubs",
	"SuitDiamonds",
	"SuitHearts",
	"SuitSpades",
	"Suitcase",
	"Suitcase2",
	"Suitcase3",
	"Suitcase4",
	"Suitcase5",
	"Suitcase6",
	"SuitcaseAlert",
	"SuitcaseArrowDown",
	"SuitcaseBolt",
	"SuitcaseBookmark",
	"SuitcaseCheck",
	"SuitcaseClip",
	"SuitcaseClock",
	"SuitcaseCloud",
	"SuitcaseDollar",
	"SuitcaseHeart",
	"SuitcaseKey",
	"SuitcaseLink",
	"SuitcaseLock",
	"SuitcaseMedical",
	"SuitcaseMinus",
	"SuitcaseMusic",
	"SuitcasePen",
	"SuitcasePin",
	"SuitcasePlus",
	"SuitcasePointer",
	"SuitcaseRefresh",
	"SuitcaseSearch",
	"SuitcaseSettings",
	"SuitcaseShield",
	"SuitcaseSparkle",
	"SuitcaseStar",
	"SuitcaseUser",
	"SummitFlag",
	"Sun",
	"SunCloud",
	"SunCloudBolt",
	"SunCloudDroplet",
	"SunCloudFog",
	"SunCloudHail",
	"SunCloudHailMixed",
	"SunCloudShowers",
	"SunCloudSnow",
	"SunFog",
	"SunHaze",
	"Sunglasses",
	"Sunrise",
	"Sunrise2",
	"Sunset",
	"Superscript",
	"Swap",
	"Sword",
	"Syringe",
	"TShirt",
	"TabClose",
	"TabOpen",
	"Table",
	"TableCode",
	"TableColDeleteLeft",
	"TableColDeleteRight",
	"TableColMergeLeftRight",
	"TableColMergeRight",
	"TableColNewLeft",
	"TableColNewLeft2",
	"TableColNewRight",
	"TableColNewRight2",
	"TableCols",
	"TableCols2",
	"TableColsMerge",
	"TableColsMinus",
	"TableColsMinus2",
	"TableColsPlus",
	"TableColsPlus2",
	"TableDownload",
	"TableLock",
	"TableRowDeleteBottom",
	"TableRowDeleteTop",
	"TableRowMergeBottom",
	"TableRowMergeTop",
	"TableRowNewBottom",
	"TableRowNewBottom2",
	"TableRowNewTop",
	"TableRowNewTop2",
	"TableRows",
	"TableRows2",
	"TableRows2Cols3",
	"TableRows3Cols2",
	"TableRows3Cols3",
	"TableRowsMerge",
	"TableRowsMinus",
	"TableRowsMinus2",
	"TableRowsPlus",
	"TableRowsPlus2",
	"TableSearch",
	"TableSettings",
	"TableSparkle",
	"TableUser",
	"Tablet",
	"TabletMobile",
	"Tabs",
	"TabsMinus",
	"TabsPlus",
	"Tag",
	"Tag2",
	"Tag3",
	"TagCheck",
	"TagMinus",
	"TagPlus",
	"TagSlash",
	"Tags",
	"TakeSelfie",
	"Target",
	"Task",
	"Task2",
	"TaskDebug",
	"TaskSearch",
	"Tasks",
	"Tasks2",
	"Taxi",
	"Teepee",
	"Telescope",
	"Temperature",
	"TemperatureDown",
	"TemperatureUp",
	"Terminal",
	"Text",
	"TextA",
	"TextASparkle",
	"TextAdjust",
	"TextAlignCenter",
	"TextAlignCenter2",
	"TextAlignJustify",
	"TextAlignJustify2",
	"TextAlignLeft",
	"TextAlignLeft2",
	"TextAlignRight",
	"TextAlignRight2",
	"TextArea",
	"TextBgColor",
	"TextBold",
	"TextColor",
	"TextColor2",
	"TextColumns",
	"TextHighlight",
	"TextHighlight2",
	"TextHighlight3",
	"TextInput",
	"TextItalic",
	"TextLowercase",
	"TextMinus",
	"TextOutdentLeft",
	"TextOutdentRight",
	"TextOverline",
	"TextPlus",
	"TextPrompt",
	"TextScaleX",
	"TextScaleY",
	"TextSize",
	"TextSizeChange",
	"TextSizeDecrease",
	"TextSizeDown",
	"TextSizeIncrease",
	"TextSizeUp",
	"TextSparkle",
	"TextStrikethrough",
	"TextTitleCase",
	"TextToImage",
	"TextToImage2",
	"TextTool",
	"TextTool2",
	"TextTracking",
	"TextUnderline",
	"TextUppercase",
	"TextXmark",
	"Texture",
	"Texture2",
	"TheatreMask",
	"TheatreMask2",
	"Thread",
	"ThreeArrowsDown",
	"ThreeArrowsLeft",
	"ThreeArrowsRight",
	"ThreeArrowsUp",
	"ThreeWayArrowMerge",
	"ThreeWayArrowSplit",
	"ThumbsDown",
	"ThumbsUp",
	"Ticket",
	"Ticket2",
	"Ticket3",
	"Ticket4",
	"TileToBottom",
	"TileToLeft",
	"TileToRight",
	"TileToTop",
	"TimelineVertical",
	"TimelineVertical2",
	"Timer",
	"Timer2",
	"TimerProgress",
	"TimerProgress2",
	"Toggle",
	"Toggle2",
	"Toggle3",
	"Toggles",
	"ToolArrow",
	"ToolMesh",
	"TopHat",
	"Tornado",
	"TouchClick",
	"TouchClick2",
	"Towel",
	"TrafficCone",
	"Train",
	"Trainer",
	"TransactionSplit",
	"Transform",
	"Transform3d",
	"Trash",
	"Trash2",
	"Trash2Content",
	"TrashContent",
	"TrashSlash",
	"TrashXmark",
	"TreasureChest",
	"TreasureMap",
	"Tree",
	"Tree2",
	"Tree3",
	"TreePalm",
	"Trees",
	"TriangleWarning",
	"Trophy",
	"Trousers",
	"Truck",
	"TruckAlert",
	"TruckCheck",
	"TruckClock",
	"TruckFast",
	"TruckHeart",
	"TruckPen",
	"TruckPin",
	"TruckRefresh",
	"TruckSearch",
	"TrueTone",
	"Tty",
	"Tv",
	"Tv2",
	"Tv3",
	"TwoArrowsDown",
	"TwoArrowsLeft",
	"TwoArrowsRight",
	"TwoArrowsUp",
	"TypeScale",
	"Typography",
	"UTurnToDown",
	"UTurnToLeft",
	"UTurnToRight",
	"UTurnToUp",
	"Ufo",
	"UiCard",
	"Umbrella",
	"UmbrellaBeach",
	"Underwear",
	"Undo",
	"Undo2",
	"Undo3",
	"Ungroup",
	"UnicornHead",
	"UnorderedList",
	"UnorderedList2",
	"Upload",
	"Upload2",
	"Upload3",
	"Upload4",
	"User",
	"UserAlert",
	"UserAlien",
	"UserArrowLeft",
	"UserArrowRight",
	"UserBan",
	"UserBookmark",
	"UserBubbleCheck",
	"UserCap",
	"UserChange",
	"UserCheck",
	"UserClock",
	"UserCloud",
	"UserConstructionWorker",
	"UserContact",
	"UserCrown",
	"UserDesigner",
	"UserDeveloper",
	"UserDots",
	"UserFeather",
	"UserFocus",
	"UserGallery",
	"UserGlobe",
	"UserGroup",
	"UserHeart",
	"UserHistory",
	"UserKey",
	"UserLaptop",
	"UserLink",
	"UserList",
	"UserLock",
	"UserLongHair",
	"UserLongHair2",
	"UserLongHair3",
	"UserLongHair4",
	"UserLongHairBadge",
	"UserLongHairShirt",
	"UserMandalorian",
	"UserMinus",
	"UserMsg",
	"UserMusic",
	"UserPanoramaView",
	"UserPen",
	"UserPhone",
	"UserPin",
	"UserPlus",
	"UserPosition",
	"UserRefresh",
	"UserSearch",
	"UserSettings",
	"UserShield",
	"UserShortHair",
	"UserShortHair2",
	"UserShortHair3",
	"UserShortHair4",
	"UserShortHair5",
	"UserShortHairBadge",
	"UserShortHairShirt",
	"UserSparkle",
	"UserStar",
	"UserSubstitution",
	"UserUpdate",
	"UserVoice",
	"UserVoice2",
	"UserXmark",
	"Users",
	"Users2",
	"Users3",
	"Users4",
	"Users5",
	"Users6",
	"UsersBookmark",
	"UsersCheck",
	"UsersCloud",
	"UsersCoin",
	"UsersDots",
	"UsersFlag",
	"UsersHeart",
	"UsersKey",
	"UsersLink",
	"UsersLock",
	"UsersMinus",
	"UsersPin",
	"UsersPlus",
	"UsersSearch",
	"UsersSeparation",
	"UsersSettings",
	"UsersShakingHands",
	"UsersShield",
	"UsersSparkle",
	"UsersStar",
	"VShapedArrowDown",
	"VShapedArrowLeft",
	"VShapedArrowRight",
	"VShapedArrowUp",
	"Vault",
	"Vault2",
	"Vault3",
	"Vault4",
	"Vector",
	"Venus",
	"Versions",
	"Versions2",
	"Vibrance",
	"Video",
	"Video2",
	"VideoOff",
	"VideoReplay",
	"ViewAll",
	"ViewAll2",
	"ViewMinusSign",
	"ViewPlusSign",
	"Views",
	"Vignette",
	"VipBadge",
	"VirtualSpace",
	"Virus",
	"VoiceCaption",
	"VoiceUser",
	"Voicemail",
	"Volume",
	"VolumeDisabled",
	"VolumeDown",
	"VolumeMinus",
	"VolumeOff",
	"VolumePlus",
	"VolumeUp",
	"VolumeXmark",
	"VrController",
	"VrHeadset",
	"VrHeadset2",
	"VrHeadset3",
	"VrHeadset4",
	"VrHeadsetSignal",
	"Wallet",
	"Wallet2",
	"Wallet2Check",
	"Wallet2Circuit",
	"Wallet2Key",
	"Wallet3",
	"WalletCheck",
	"WalletCoin",
	"WalletCoins",
	"WalletContent",
	"WalletKey",
	"WandSparkle",
	"Watch",
	"Watch2",
	"Watch2Heart",
	"Watch3",
	"WaterLevelDown",
	"WaterLevelUp",
	"WaterSurface",
	"WaterWave",
	"WaveformLines",
	"Webcam",
	"Webhook",
	"Weight",
	"WeightScale",
	"WidthMax",
	"WidthMin",
	"Wifi",
	"WifiOff",
	"Wind",
	"Window",
	"Window2",
	"WindowAlert",
	"WindowBan",
	"WindowBookmark",
	"WindowBottom",
	"WindowBottomLeft",
	"WindowBottomRight",
	"WindowCenter",
	"WindowChartLine",
	"WindowChartLine2",
	"WindowClock",
	"WindowCode",
	"WindowCode2",
	"WindowDownload",
	"WindowEdit",
	"WindowExpandBottomLeft",
	"WindowExpandBottomRight",
	"WindowExpandTopLeft",
	"WindowExpandTopRight",
	"WindowFullScreen",
	"WindowHeart",
	"WindowKey",
	"WindowLayout",
	"WindowLeft",
	"WindowLink",
	"WindowLock",
	"WindowMinus",
	"WindowMinus2",
	"WindowPaintbrush",
	"WindowPlus",
	"WindowPlus2",
	"WindowPointer",
	"WindowRefresh",
	"WindowResizeX",
	"WindowResizeX2",
	"WindowResizeY",
	"WindowRight",
	"WindowSearch",
	"WindowSettings",
	"WindowShare",
	"WindowShield",
	"WindowSparkle",
	"WindowTop",
	"WindowTopLeft",
	"WindowTopRight",
	"WindowUser",
	"WindshieldCleaner",
	"Windsock",
	"WineGlass",
	"Wip",
	"Workflow",
	"WorkflowDenied",
	"Workstation",
	"Workstation2",
	"Wrench",
	"WrenchScrewdriver",
	"Xmark",
	"XmasDecoration",
	"XmasDecorations",
	"Yoga",
	"YogaMat",
]
